import Vue from "vue";
import Vuex from "vuex";
import { getPricesCdt } from "../services/prices.service"; // Importa o serviço

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    modal: true,
    partners: [],
    cdtPrices: {
      anuidadeTimes: "0",
      clinico_geral: 0,
      dateTime: "",
      demais: 0,
      valor: "0",
    }
  },
  getters: {
    modal: (state) => state.modal,
    partners: (state) => state.partners,
    cdtPrices: (state) => state.cdtPrices,
  },
  mutations: {
    CHANGE_MODAL: (state) => {
      state.modal = !state.modal;
    },
    CHANGE_PARTNERS: (state, value) => {
      state.partners = value;
    },
    SET_CDT_PRICES: (state, prices) => {
      state.cdtPrices = prices; // Atualiza cdtPrices com os dados dinâmicos
    },
  },
  actions: {
    setPartners(context, payload) {
      context.commit("CHANGE_PARTNERS", payload);
    },
    async fetchCdtPrices({ commit }) {
      try {
        const prices = await getPricesCdt(); // Chama o serviço para obter os preços
        commit("SET_CDT_PRICES", prices); // Atualiza a propriedade na store
      } catch (error) {
        console.error("Erro ao buscar os preços:", error);
      }
    },
  },
  modules: {}
});
